
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutggSyfwPOiegJwjzpMxxmGa4rt2XKQTgm9LWnC3i_iHgMeta } from "G:/00_Project/4_Technomac-snc/pages/about.vue?macro=true";
import { default as indexXt3VpKUdrPaxxnCyijfZXuIO486_GkZ_45Q_45qnhl_mOdwMeta } from "G:/00_Project/4_Technomac-snc/pages/index.vue?macro=true";
import { default as contactoebJim7zoSJ_Kkba8nK8ItAMvMlamJorWJ_X8KSGvSkMeta } from "G:/00_Project/4_Technomac-snc/pages/contact.vue?macro=true";
import { default as indexS_AnegoXnj6lXscKh3ewESSy0cJOalft6Xj2oNnYDE4Meta } from "G:/00_Project/4_Technomac-snc/pages/admin/index.vue?macro=true";
import { default as loginbhVGCt4XgiI4l4Jk4jvLugSIL7wPj36C11UBdZkZl_45wMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/login.vue?macro=true";
import { default as manutentionWHYeynkR5V_45AereBJZSEwBEJ5ItGfqn59N1U22yQaEYMeta } from "G:/00_Project/4_Technomac-snc/pages/manutention.vue?macro=true";
import { default as profileVxhOanh195M7FwOsyHHukZc6sdS9M1TnCpWIleKI9XEMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/profile.vue?macro=true";
import { default as _91id_93aZlGlevrnn1DIE5nV1GbRWMkiFWbXSVa07DiYobqO_UMeta } from "G:/00_Project/4_Technomac-snc/pages/machines/[id].vue?macro=true";
import { default as indexubSbdoaDQSdTOilhcF3WBGBfUuVw2Dd_GG0lLC9abA4Meta } from "G:/00_Project/4_Technomac-snc/pages/machines/index.vue?macro=true";
import { default as analytics5ngeztXOJCtzQ37_45a3BstrgjyBIr9Hy8Np6ghWbARIsMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/analytics.vue?macro=true";
import { default as appearancew3qbS1YELe_dP_452vzyTw57Ly_457WmRFOJ0zYekMWAX2AMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/appearance.vue?macro=true";
import { default as _91id_93T0MgATzsLeSsVW1UIIVVeXQLpvXiznYCkvXIEaWtYbwMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/stats/[id].vue?macro=true";
import { default as _91id_93bZNUOFt_jQbwZtGqC_Lf0JiCB5JzuM3tdDvnUs6qsoEMeta } from "G:/00_Project/4_Technomac-snc/pages/spare-parts/[id].vue?macro=true";
import { default as showN9gOGUhDimX4CfctYCeuNNkTvDegLXvGSpmOoMrjWQUMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/admins/show.vue?macro=true";
import { default as indexziHc3UY6O3bcSOvcuGcuCoXhu8FqqpKmo3FGT1Iv_uIMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/stats/index.vue?macro=true";
import { default as indexFFHgqrwo4o4C07D7EDJdGjGZu6qSmRqjPGj2UhSDyDAMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/users/index.vue?macro=true";
import { default as index5N7RjyeW9UkLyAlFh8EKRr4ZrIlV9EotnJQ0_Ey6v7kMeta } from "G:/00_Project/4_Technomac-snc/pages/spare-parts/index.vue?macro=true";
import { default as indexOzrsoqi8rCc8V0rkhsC_RVorlHWdQ1RrUPJYqrbIu3YMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/admins/index.vue?macro=true";
import { default as indexSseT70YCVoOEbvEQDl0GkLsh9HspxAQSpqTbdiV_45KqYMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/brands/index.vue?macro=true";
import { default as createmwwhMUKUhtdqzZr5CkkItGm3YYAprubkKsFzwXyRKEAMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/admins/create.vue?macro=true";
import { default as billsFLIH_E5nMUMRT_45Kv6h08TDZDv71iXaIhoKQIPCM6HScMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/billing/bills.vue?macro=true";
import { default as createwYTVRWobSodGLGPbTOCCEwguDl66tI35Z2RGf2Zz7ycMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/brands/create.vue?macro=true";
import { default as indexkliZf9kEtPZNGjhkTNmqJL5kGP4IdqYrJPUmWDZONvoMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/content/index.vue?macro=true";
import { default as editP6mmB1Y1xAhM1NiNRMXu_45Livj_qC8db28XjrieKoLHoMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/services/edit.vue?macro=true";
import { default as indexElPT40FLl0qJGshb9V_45ZUhv6D8kROhZ375xd9gcoRyEMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/contacts/index.vue?macro=true";
import { default as indexxIi9VZV1UOXgJHKOJ9mjnWpP13DJcgd5HMBFGNOEffcMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/machines/index.vue?macro=true";
import { default as indexcS3WmAcMn71JeK52E_45EuL_45tolDrhVB3JpdPXffN0i9sMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/services/index.vue?macro=true";
import { default as clientsf6CucZ9ih7ndY_453X_yW1kpwzpBQrfj8_eGC4eFeQj1wMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/billing/clients.vue?macro=true";
import { default as editLxjymW22KuQRP4aL66ADsAX8ZULt4FAvKThaqvdYl7UMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/categories/edit.vue?macro=true";
import { default as showQOy4V6izUlaYBwOvDfh9npV1pkqnHRfY93G7_rlpeYUMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/categories/show.vue?macro=true";
import { default as forgot_45password39Z9_fxXuFPlfmPMXMUTqoIl3vNFo6pqcGM92FujwkEMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/forgot-password.vue?macro=true";
import { default as createeuua1ic9rdclffHGIonRsDu4GXDziOza8NqPMGAcFIsMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/machines/create.vue?macro=true";
import { default as createWjuYIlQ7AqxetNVPBxqRVvhsWvpeJczbSiB_45fW30YHIMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/services/create.vue?macro=true";
import { default as statsvn_450Y1CZ_LIZCTiah_y7N5laSgKF0iyAipr_DrnWUX0Meta } from "G:/00_Project/4_Technomac-snc/pages/admin/accounting/stats.vue?macro=true";
import { default as editDVDofptA6mVcXYrFmZpN2Ydkrr2ut39gsEBkOL2nIJsMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/admins/[id]/edit.vue?macro=true";
import { default as invoicesm5wLTlSfB3Eqh3pStofj2VOToEsGRYT2dbryZaLSzroMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/billing/invoices.vue?macro=true";
import { default as editE09kEMksDQBXewwhefsqeQg_PrNtn_45i1vAsFwZG_lQAMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/brands/[id]/edit.vue?macro=true";
import { default as showjUQjGrFiB1tHkVC7ZfnTd_WHr2xTEwjqgz8IWuGYcU0Meta } from "G:/00_Project/4_Technomac-snc/pages/admin/brands/[id]/show.vue?macro=true";
import { default as indexUmnxlucpW3M3CcoEjueiKAXWF_wbQZM8xno4T1cIO8UMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/categories/index.vue?macro=true";
import { default as dashboardQg9UzTeOmXuHXKVmkxfUs9Iu7vVbCkgyE0_S6GiZ6skMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/billing/dashboard.vue?macro=true";
import { default as proformasN4X6Z1uzzDn_qd7Svjl5u1H8rwmx0C1MKAWEZTSNbgUMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/billing/proformas.vue?macro=true";
import { default as createFuiyH7SfpnRqmo_ZLEV_45w5a4SPmeHI7OFN7qGkCsVeIMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/categories/create.vue?macro=true";
import { default as indexchGdn46Xc22lW9I_45tp9EvxMH01icRnvsXwp_49Z3knoMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/index.vue?macro=true";
import { default as showBwfajDFpt3KucEPb7zd_45GGWejcRWpxYp_ZPmg5KgQ_AMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/contacts/[id]/show.vue?macro=true";
import { default as editDRFXxiRAQ38lxD0iS4y1sS_OVhmWgLH1P2MB2NnMl08Meta } from "G:/00_Project/4_Technomac-snc/pages/admin/machines/[id]/edit.vue?macro=true";
import { default as showBdNmlr79d3hCrbv0hR2lo4UwPTkXjMymSw4T1UnlmlEMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/machines/[id]/show.vue?macro=true";
import { default as createEMXKvvnMVcUzqrGFCVgJlgcWv5K3k2dc_GHL7zGL00QMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/create.vue?macro=true";
import { default as indexM_45TMIbKJ_45omDug2fqQBGEWWoNBW2n0DESjmKmn_45Oy54Meta } from "G:/00_Project/4_Technomac-snc/pages/admin/machines/[id]/index.vue?macro=true";
import { default as indexeNVHErAtsNs9JlznUayTllkG7_UkXVz7uUmX7lrXilYMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/notifications/index.vue?macro=true";
import { default as _91id_93yQdXAp1SDsZtcAnTVjDBkh2NYiVpuwNsfE21QRSwxrIMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/email-campaigns/[id].vue?macro=true";
import { default as indexAwwZ2tymyws87WDY6pDMEOopFT0MzYK_A3CmQC5vgzoMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/email-campaigns/index.vue?macro=true";
import { default as editu_45InbELmQk1pwJxU8hszx8QEFxj7IPBw3fUPdwn3KWgMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/[id]/edit.vue?macro=true";
import { default as indexXWj6MVajGe6MJ5g1m_AnTof_I6gGAKnqFvJjXB1YqXgMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/accounting/bills/index.vue?macro=true";
import { default as _91id_93Lx79XctPYKwfNW6h5R6qz4K0Cqdta5Wyod_KEciW_45_4Meta } from "G:/00_Project/4_Technomac-snc/pages/admin/billing/suppliers/[id].vue?macro=true";
import { default as createcbFiGGwIbQAeD6XWWSIeH63hI_45Gd8af1VV9G_eLyZfkMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/email-campaigns/create.vue?macro=true";
import { default as indexWIWR6QFR3kV95Wh6G2lwltLrir9Bf1xbDf9ZPHAIUfwMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/[id]/index.vue?macro=true";
import { default as indexQwXKXM7l0lKzSa3LVv68WJSN0Jp61knw8dLkezPn8nYMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/email-subscribers/index.vue?macro=true";
import { default as indexmcG_8YFQv3IqFqkrc2O9G3Pf2pr_eUrVd3KO89UIJFMMeta } from "G:/00_Project/4_Technomac-snc/pages/admin/accounting/invoices/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("G:/00_Project/4_Technomac-snc/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("G:/00_Project/4_Technomac-snc/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("G:/00_Project/4_Technomac-snc/pages/contact.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexS_AnegoXnj6lXscKh3ewESSy0cJOalft6Xj2oNnYDE4Meta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: loginbhVGCt4XgiI4l4Jk4jvLugSIL7wPj36C11UBdZkZl_45wMeta || {},
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/login.vue")
  },
  {
    name: "manutention",
    path: "/manutention",
    component: () => import("G:/00_Project/4_Technomac-snc/pages/manutention.vue")
  },
  {
    name: "admin-profile",
    path: "/admin/profile",
    meta: { ...(profileVxhOanh195M7FwOsyHHukZc6sdS9M1TnCpWIleKI9XEMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/profile.vue")
  },
  {
    name: "machines-id",
    path: "/machines/:id()",
    meta: _91id_93aZlGlevrnn1DIE5nV1GbRWMkiFWbXSVa07DiYobqO_UMeta || {},
    component: () => import("G:/00_Project/4_Technomac-snc/pages/machines/[id].vue")
  },
  {
    name: "machines",
    path: "/machines",
    component: () => import("G:/00_Project/4_Technomac-snc/pages/machines/index.vue")
  },
  {
    name: "admin-analytics",
    path: "/admin/analytics",
    meta: { ...(analytics5ngeztXOJCtzQ37_45a3BstrgjyBIr9Hy8Np6ghWbARIsMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/analytics.vue")
  },
  {
    name: "admin-appearance",
    path: "/admin/appearance",
    meta: { ...(appearancew3qbS1YELe_dP_452vzyTw57Ly_457WmRFOJ0zYekMWAX2AMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/appearance.vue")
  },
  {
    name: "admin-stats-id",
    path: "/admin/stats/:id()",
    meta: { ...(_91id_93T0MgATzsLeSsVW1UIIVVeXQLpvXiznYCkvXIEaWtYbwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/stats/[id].vue")
  },
  {
    name: "spare-parts-id",
    path: "/spare-parts/:id()",
    meta: _91id_93bZNUOFt_jQbwZtGqC_Lf0JiCB5JzuM3tdDvnUs6qsoEMeta || {},
    component: () => import("G:/00_Project/4_Technomac-snc/pages/spare-parts/[id].vue")
  },
  {
    name: "admin-admins-show",
    path: "/admin/admins/show",
    meta: { ...(showN9gOGUhDimX4CfctYCeuNNkTvDegLXvGSpmOoMrjWQUMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/admins/show.vue")
  },
  {
    name: "admin-stats",
    path: "/admin/stats",
    meta: { ...(indexziHc3UY6O3bcSOvcuGcuCoXhu8FqqpKmo3FGT1Iv_uIMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/stats/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(indexFFHgqrwo4o4C07D7EDJdGjGZu6qSmRqjPGj2UhSDyDAMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/users/index.vue")
  },
  {
    name: "spare-parts",
    path: "/spare-parts",
    component: () => import("G:/00_Project/4_Technomac-snc/pages/spare-parts/index.vue")
  },
  {
    name: "admin-admins",
    path: "/admin/admins",
    meta: { ...(indexOzrsoqi8rCc8V0rkhsC_RVorlHWdQ1RrUPJYqrbIu3YMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/admins/index.vue")
  },
  {
    name: "admin-brands",
    path: "/admin/brands",
    meta: { ...(indexSseT70YCVoOEbvEQDl0GkLsh9HspxAQSpqTbdiV_45KqYMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/brands/index.vue")
  },
  {
    name: "admin-admins-create",
    path: "/admin/admins/create",
    meta: { ...(createmwwhMUKUhtdqzZr5CkkItGm3YYAprubkKsFzwXyRKEAMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/admins/create.vue")
  },
  {
    name: "admin-billing-bills",
    path: "/admin/billing/bills",
    meta: { ...(billsFLIH_E5nMUMRT_45Kv6h08TDZDv71iXaIhoKQIPCM6HScMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/billing/bills.vue")
  },
  {
    name: "admin-brands-create",
    path: "/admin/brands/create",
    meta: { ...(createwYTVRWobSodGLGPbTOCCEwguDl66tI35Z2RGf2Zz7ycMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/brands/create.vue")
  },
  {
    name: "admin-content",
    path: "/admin/content",
    meta: { ...(indexkliZf9kEtPZNGjhkTNmqJL5kGP4IdqYrJPUmWDZONvoMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/content/index.vue")
  },
  {
    name: "admin-services-edit",
    path: "/admin/services/edit",
    meta: { ...(editP6mmB1Y1xAhM1NiNRMXu_45Livj_qC8db28XjrieKoLHoMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/services/edit.vue")
  },
  {
    name: "admin-contacts",
    path: "/admin/contacts",
    meta: { ...(indexElPT40FLl0qJGshb9V_45ZUhv6D8kROhZ375xd9gcoRyEMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/contacts/index.vue")
  },
  {
    name: "admin-machines",
    path: "/admin/machines",
    meta: { ...(indexxIi9VZV1UOXgJHKOJ9mjnWpP13DJcgd5HMBFGNOEffcMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/machines/index.vue")
  },
  {
    name: "admin-services",
    path: "/admin/services",
    meta: { ...(indexcS3WmAcMn71JeK52E_45EuL_45tolDrhVB3JpdPXffN0i9sMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/services/index.vue")
  },
  {
    name: "admin-billing-clients",
    path: "/admin/billing/clients",
    meta: { ...(clientsf6CucZ9ih7ndY_453X_yW1kpwzpBQrfj8_eGC4eFeQj1wMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/billing/clients.vue")
  },
  {
    name: "admin-categories-edit",
    path: "/admin/categories/edit",
    meta: { ...(editLxjymW22KuQRP4aL66ADsAX8ZULt4FAvKThaqvdYl7UMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/categories/edit.vue")
  },
  {
    name: "admin-categories-show",
    path: "/admin/categories/show",
    meta: { ...(showQOy4V6izUlaYBwOvDfh9npV1pkqnHRfY93G7_rlpeYUMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/categories/show.vue")
  },
  {
    name: "admin-forgot-password",
    path: "/admin/forgot-password",
    meta: { ...(forgot_45password39Z9_fxXuFPlfmPMXMUTqoIl3vNFo6pqcGM92FujwkEMeta || {}), ...{"middleware":"guest"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/forgot-password.vue")
  },
  {
    name: "admin-machines-create",
    path: "/admin/machines/create",
    meta: { ...(createeuua1ic9rdclffHGIonRsDu4GXDziOza8NqPMGAcFIsMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/machines/create.vue")
  },
  {
    name: "admin-services-create",
    path: "/admin/services/create",
    meta: { ...(createWjuYIlQ7AqxetNVPBxqRVvhsWvpeJczbSiB_45fW30YHIMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/services/create.vue")
  },
  {
    name: "admin-accounting-stats",
    path: "/admin/accounting/stats",
    meta: { ...(statsvn_450Y1CZ_LIZCTiah_y7N5laSgKF0iyAipr_DrnWUX0Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/accounting/stats.vue")
  },
  {
    name: "admin-admins-id-edit",
    path: "/admin/admins/:id()/edit",
    meta: { ...(editDVDofptA6mVcXYrFmZpN2Ydkrr2ut39gsEBkOL2nIJsMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/admins/[id]/edit.vue")
  },
  {
    name: "admin-billing-invoices",
    path: "/admin/billing/invoices",
    meta: { ...(invoicesm5wLTlSfB3Eqh3pStofj2VOToEsGRYT2dbryZaLSzroMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/billing/invoices.vue")
  },
  {
    name: "admin-brands-id-edit",
    path: "/admin/brands/:id()/edit",
    meta: { ...(editE09kEMksDQBXewwhefsqeQg_PrNtn_45i1vAsFwZG_lQAMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/brands/[id]/edit.vue")
  },
  {
    name: "admin-brands-id-show",
    path: "/admin/brands/:id()/show",
    meta: { ...(showjUQjGrFiB1tHkVC7ZfnTd_WHr2xTEwjqgz8IWuGYcU0Meta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/brands/[id]/show.vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: { ...(indexUmnxlucpW3M3CcoEjueiKAXWF_wbQZM8xno4T1cIO8UMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/categories/index.vue")
  },
  {
    name: "admin-billing-dashboard",
    path: "/admin/billing/dashboard",
    meta: { ...(dashboardQg9UzTeOmXuHXKVmkxfUs9Iu7vVbCkgyE0_S6GiZ6skMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/billing/dashboard.vue")
  },
  {
    name: "admin-billing-proformas",
    path: "/admin/billing/proformas",
    meta: { ...(proformasN4X6Z1uzzDn_qd7Svjl5u1H8rwmx0C1MKAWEZTSNbgUMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/billing/proformas.vue")
  },
  {
    name: "admin-categories-create",
    path: "/admin/categories/create",
    meta: { ...(createFuiyH7SfpnRqmo_ZLEV_45w5a4SPmeHI7OFN7qGkCsVeIMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/categories/create.vue")
  },
  {
    name: "admin-spare-parts",
    path: "/admin/spare-parts",
    meta: { ...(indexchGdn46Xc22lW9I_45tp9EvxMH01icRnvsXwp_49Z3knoMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/index.vue")
  },
  {
    name: "admin-contacts-id-show",
    path: "/admin/contacts/:id()/show",
    meta: showBwfajDFpt3KucEPb7zd_45GGWejcRWpxYp_ZPmg5KgQ_AMeta || {},
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/contacts/[id]/show.vue")
  },
  {
    name: "admin-machines-id-edit",
    path: "/admin/machines/:id()/edit",
    meta: { ...(editDRFXxiRAQ38lxD0iS4y1sS_OVhmWgLH1P2MB2NnMl08Meta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/machines/[id]/edit.vue")
  },
  {
    name: "admin-machines-id-show",
    path: "/admin/machines/:id()/show",
    meta: { ...(showBdNmlr79d3hCrbv0hR2lo4UwPTkXjMymSw4T1UnlmlEMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/machines/[id]/show.vue")
  },
  {
    name: "admin-spare-parts-create",
    path: "/admin/spare-parts/create",
    meta: { ...(createEMXKvvnMVcUzqrGFCVgJlgcWv5K3k2dc_GHL7zGL00QMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/create.vue")
  },
  {
    name: "admin-machines-id",
    path: "/admin/machines/:id()",
    meta: { ...(indexM_45TMIbKJ_45omDug2fqQBGEWWoNBW2n0DESjmKmn_45Oy54Meta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/machines/[id]/index.vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    meta: { ...(indexeNVHErAtsNs9JlznUayTllkG7_UkXVz7uUmX7lrXilYMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/notifications/index.vue")
  },
  {
    name: "admin-email-campaigns-id",
    path: "/admin/email-campaigns/:id()",
    meta: { ...(_91id_93yQdXAp1SDsZtcAnTVjDBkh2NYiVpuwNsfE21QRSwxrIMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/email-campaigns/[id].vue")
  },
  {
    name: "admin-email-campaigns",
    path: "/admin/email-campaigns",
    meta: { ...(indexAwwZ2tymyws87WDY6pDMEOopFT0MzYK_A3CmQC5vgzoMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/email-campaigns/index.vue")
  },
  {
    name: "admin-spare-parts-id-edit",
    path: "/admin/spare-parts/:id()/edit",
    meta: { ...(editu_45InbELmQk1pwJxU8hszx8QEFxj7IPBw3fUPdwn3KWgMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/[id]/edit.vue")
  },
  {
    name: "admin-accounting-bills",
    path: "/admin/accounting/bills",
    meta: { ...(indexXWj6MVajGe6MJ5g1m_AnTof_I6gGAKnqFvJjXB1YqXgMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/accounting/bills/index.vue")
  },
  {
    name: "admin-billing-suppliers-id",
    path: "/admin/billing/suppliers/:id()",
    meta: { ...(_91id_93Lx79XctPYKwfNW6h5R6qz4K0Cqdta5Wyod_KEciW_45_4Meta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/billing/suppliers/[id].vue")
  },
  {
    name: "admin-email-campaigns-create",
    path: "/admin/email-campaigns/create",
    meta: { ...(createcbFiGGwIbQAeD6XWWSIeH63hI_45Gd8af1VV9G_eLyZfkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/email-campaigns/create.vue")
  },
  {
    name: "admin-spare-parts-id",
    path: "/admin/spare-parts/:id()",
    meta: { ...(indexWIWR6QFR3kV95Wh6G2lwltLrir9Bf1xbDf9ZPHAIUfwMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/spare-parts/[id]/index.vue")
  },
  {
    name: "admin-email-subscribers",
    path: "/admin/email-subscribers",
    meta: { ...(indexQwXKXM7l0lKzSa3LVv68WJSN0Jp61knw8dLkezPn8nYMeta || {}), ...{"middleware":"admin"} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/email-subscribers/index.vue")
  },
  {
    name: "admin-accounting-invoices",
    path: "/admin/accounting/invoices",
    meta: { ...(indexmcG_8YFQv3IqFqkrc2O9G3Pf2pr_eUrVd3KO89UIJFMMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("G:/00_Project/4_Technomac-snc/pages/admin/accounting/invoices/index.vue")
  }
]